import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import BgImg from "../../../images/landing/software-development/stockship_banner.webp";

function Kinect() {
  return (
    <section
      className="mobiuscase kinekt_case p-100 text_white"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto ">
            <div className="mob_icon">
              <StaticImage
                src="../../../images/landing/software-development/kinect_logo.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={407}
                height={102}
              />
            </div>
            <p>
              Kinder Morgan has a mobile app, Kinetrex Energy, and TekRevol has
              completed the app code review to gauge its performance and
              usability
            </p>
            <Link
              to="/projects"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              View Case Study
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-md-1 mt-4 mt-md-0"
          >
            <StaticImage
              src="../../../images/landing/software-development/kinect.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={880}
              height={559}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Kinect;
